import Header from "../componentes/Header";
import MemberSection from "../componentes/MemberSection";

function Members() {
    return(
        <>
            <Header />
            <MemberSection />
        </>
    )
}

export default Members;